import {SERVER_URL} from '../.config';

export const SAVE_MATCH_RESULT_ASYNC = 'SAVE_MATCH_RESULT_ASYNC';
export const saveMatchResultsAsync = (socket, jsonPayload) => dispatch =>{
    fetch(`${SERVER_URL}history`, jsonPayload);
};

export const GET_MATCH_RESULTS_ASYNC = 'GET_MATCH_RESULTS_ASYNC';
export const getMatchResultsAsync = (payload, uuid)=> dispatch =>{
    fetch(`${SERVER_URL}history/${uuid}`, payload)
        .then(res=>{
            if(!res.ok){
                return Promise.reject(res.statusText)
            }
            return res.json();
        })
        .then(res=>{
            dispatch(storePastMatchResults(res));
        })
};

export const STORE_PAST_MATCH_RESULTS = 'STORE_PAST_MATCH_RESULTS';
export const storePastMatchResults = (jsonObj) =>({
    type: STORE_PAST_MATCH_RESULTS,
    jsonObj
});

export const RESET_HISTORY_STATE = 'RESET_HISTORY_STATE';
export const resetHistoryState = ()=>({
    type: RESET_HISTORY_STATE
});


// WEBPACK FOOTER //
// ./src/actions/history.js